import Vue from 'vue';
import { MtIcon } from '../MtIcon';
import './MtSpinner.css';
import '../MtIcon/svg/spinner.svg';
export default Vue.extend({
    name: 'MtSpinner',
    render: function (h) {
        var icon = h(MtIcon, {
            staticClass: 'mt-spinner__icon',
            props: {
                glyph: 'spinner',
                width: '1em',
                height: '1em',
            },
        });
        return h('span', {
            staticClass: 'mt-spinner',
        }, [icon]);
    },
});
//# sourceMappingURL=MtSpinner.js.map